import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/clientes')({
  component: lazyRouteComponent(
    () => import('@/features/clientes-dashboard/components/clientes-dashboard'),
    'ClientesDashboard'
  ),
})
